<template>
  <div class="location">
    <img :src="this.publicData.serverUrl + 'images/map.png'" alt="">
  </div>
</template>

<script>
export default {
  name: 'location',
  components: {},
  props: [],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.location {
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 20px;
  border-radius: 5px;
    img {
      width: 100%;
      height: 100%;
    }
}
</style>